import { FormattedText } from '../../components/FormattedText/FormattedText';
import { FormattedTitle } from '../../components/FormattedTitle/FormattedTitle';
import { BulletList } from '../components/BulletList/BulletList';
import { Callout } from '../components/Callout/Callout';
import { Disclaimer } from '../components/Disclaimer/Disclaimer';
import { Image } from '../components/Image/Image';
import { NumberedList } from '../components/NumberedList/NumberedList';
import { QuestionAnswer } from '../components/QuestionAnswer/QuestionAnswer';

const components = {
  image: ({
    key, alt, src
  }) => <Image key={key} alt={alt} src={src} />,
  title: ({ key, title }) => <FormattedTitle key={key} variant="huge" dirtyTitle={title} />,
  subtitle: ({ key, subtitle }) => <FormattedTitle key={key} level={3} variant="mediumAlt" dirtyTitle={subtitle} />,
  callout: ({ key, message }) => <Callout key={key} message={message} />,
  numberedList: ({ key, listItems }) => <NumberedList key={key} listItems={listItems} />,
  questionAnswer: ({
    question,
    answer,
    key
  }) => <QuestionAnswer key={key} question={question} answer={answer} />,
  bulletList: ({ key, listItems }) => <BulletList key={key} listItems={listItems} />,
  emphasizedParagraph: ({ key, text }) => <FormattedText key={key} size="xl" bold dirtyText={text} />,
  simpleParagraph: ({ key, text }) => <FormattedText key={key} dirtyText={text} />,
  boldParagraph: ({ key, text }) => <FormattedText size="md" bold key={key} dirtyText={text} />,
  disclaimer: ({ key, title, text }) => (
    <Disclaimer key={key} dirtyTitle={title} dirtyText={text} />
  ),
  mediumText: ({ key, text }) => <FormattedText key={key} size="md" dirtyText={text} />,
  extraLargeText: ({ key, text }) => <FormattedText key={key} size="xl" dirtyText={text} />
};

export const componentRendering = (content = []) => {
  const renderedComponents = content.map((props) => {
    const component = components[props.component];
    return component && component(props);
  });

  return renderedComponents;
};
